(() => {
  if (window.__olivinePdpGalleryVideo) return;
  window.__olivinePdpGalleryVideo = true;

  const ensureMutedInline = (video) => {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;
    video.setAttribute('loop', '');
  };

  const tryPlay = (video) => {
    if (!video) return;
    ensureMutedInline(video);
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(() => {});
    }
  };

  const playVideosIn = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('[data-pdp-gallery-video] video').forEach((video) => {
      tryPlay(video);
    });
  };

  const pauseAllVideos = (exceptRoot = null) => {
    document.querySelectorAll('[data-pdp-gallery-video]').forEach((root) => {
      if (exceptRoot && root === exceptRoot) return;
      const video = root.querySelector('video');
      if (video && !video.paused) {
        video.pause();
      }
    });
  };

  const syncVisibleVideos = (sliderRoot) => {
    if (!sliderRoot) {
      initVideos();
      return;
    }

    const selected =
      sliderRoot.querySelector('.flickity-slider > .is-selected') ||
      sliderRoot.querySelector('.is-selected');

    pauseAllVideos();
    if (selected) {
      playVideosIn(selected);
    }
  };

  const initVideos = (scope = document) => {
    scope.querySelectorAll('[data-pdp-gallery-video] video').forEach((video) => {
      ensureMutedInline(video);
      tryPlay(video);
    });
  };

  // Reintentar play cuando el video está listo (Safari a veces bloquea el primer intento).
  document.addEventListener(
    'loadeddata',
    (event) => {
      const video = event.target;
      if (!video?.matches?.('[data-pdp-gallery-video] video')) return;
      tryPlay(video);
    },
    true
  );

  document.addEventListener(
    'canplay',
    (event) => {
      const video = event.target;
      if (!video?.matches?.('[data-pdp-gallery-video] video')) return;
      if (video.paused) tryPlay(video);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVideos(), { once: true });
  } else {
    initVideos();
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      initVideos();
    }
  });

  window.olivinePausePdpGalleryVideos = pauseAllVideos;
  window.olivinePlayPdpGalleryVideos = initVideos;
  window.olivineSyncPdpGalleryVideos = syncVisibleVideos;
})();
